import { CONFIG } from 'shared/config';
import { useAxios } from 'shared/hooks/useAxios';
import {
  ICityResponsePayload,
  ICountryResponsePayload,
  IStateResponsePayload,
  ICountryPhoneCodeResponsePayload,
} from 'shared/interfaces/utils/ICountryStateApi';

const { GET } = useAxios();
export const countryStateApiDao = () => {
  const getCountries = async () => {
    const response = await GET<ICountryResponsePayload>({
      url: `${CONFIG.COUNTRY_STATE_API_URL}/countries`,
      headers: {
        'X-CSCAPI-KEY': CONFIG.COUNTRY_STATE_API_KEY,
      },
    });

    return response.data;
  };

  const getStatesByCountry = async (countryCode: string) => {
    const response = await GET<IStateResponsePayload>({
      url: `${CONFIG.COUNTRY_STATE_API_URL}/countries/${countryCode}/states`,
      headers: {
        'X-CSCAPI-KEY': CONFIG.COUNTRY_STATE_API_KEY,
      },
    });

    return response.data;
  };

  const getCitiesByStateAndCountry = async (countryCode: string, stateCode: string) => {
    const response = await GET<ICityResponsePayload>({
      url: `${CONFIG.COUNTRY_STATE_API_URL}/countries/${countryCode}/states/${stateCode}/cities`,
      headers: {
        'X-CSCAPI-KEY': CONFIG.COUNTRY_STATE_API_KEY,
      },
    });

    return response.data;
  };

  const getPhoneCodeByCountry = async (countryCode: string) => {
    const response = await GET<ICountryPhoneCodeResponsePayload>({
      url: `${CONFIG.COUNTRY_STATE_API_URL}/countries/${countryCode}`,
      headers: {
        'X-CSCAPI-KEY': CONFIG.COUNTRY_STATE_API_KEY,
      },
    });

    return response.data;
  };

  const getAllStates = async () => {
    const response = await GET<IStateResponsePayload>({
      url: `${CONFIG.COUNTRY_STATE_API_URL}/states`,
      headers: {
        'X-CSCAPI-KEY': CONFIG.COUNTRY_STATE_API_KEY,
      },
    });

    return response.data;
  };

  return {
    getCountries,
    getStatesByCountry,
    getCitiesByStateAndCountry,
    getPhoneCodeByCountry,
    getAllStates,
  };
};
